
import Axios, { AxiosPromise } from "axios";
import { WebHelper } from "../../helpers/WebHelper";
import { IUserColumns, IUserPortalDetails } from './User';
import { AuthHelper } from 'src/helpers/AuthHelper';
import { keepLocal } from 'src';
import { PortalDummyAPI } from '../DataDummy/DataApi';


export class UserService{    
    public static getUserDetails() : AxiosPromise<IUserColumns> {
        try{
                const userToken = AuthHelper.GetUserToken();
                if(userToken === undefined || userToken === ''){
                    throw Error("UserService -Details-> token not set");
                }
                WebHelper.Instance.headers = 
                { 
                    'Authorization': "Bearer " + userToken,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-Client': 'application',
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
                const webInstance = WebHelper.Instance.getAxiosInstance();   
                   
                return webInstance.get('user/details');
           
            
        }catch (error) {
            throw error;
        }
    }  

    public static getRefreshUserToken(): AxiosPromise<string>{
        try{
            const userToken = AuthHelper.GetUserToken();
                if(userToken === undefined || userToken === ''){
                    throw Error("UserService -refresh user token-> token not set");
                }
                WebHelper.Instance.headers = 
                { 
                    'Authorization': "Bearer " + userToken,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-Client': 'application',
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
                const webInstance = WebHelper.Instance.getAxiosInstance();   
                   
                return webInstance.get('authorization/refreshtoken');
        }catch (error) {
            throw error;
        }

    } 
    public static  getLocalUserDetails () : any{
        return PortalDummyAPI.GetLocalUserDetail();
    }


    public static getUserPortalDetails(): AxiosPromise<IUserPortalDetails> {
        try{
            const userToken = AuthHelper.GetUserToken();
            if(userToken === undefined || userToken === ''){
                throw Error("UserService -getUserPortalDetails-> token not set");
            }
            WebHelper.Instance.headers = 
            { 
                'Authorization': "Bearer " + userToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-Client': 'application',
                'Pragma': 'no-cache',
                'Cache-Control': 'no-cache'
            }
            const webInstance = WebHelper.Instance.getAxiosInstance();            
            return webInstance.get('activity/GetUserPortalData');
        }catch (error) {
            throw error;
        }
    }
    
    public static  getLocalUserPoratlDetails () : any{
        return PortalDummyAPI.GetLocalUserPortalDetail();
    }
    
    public static setUserFavoriteCourse(courseId: number): AxiosPromise<any> {
        try{
            const userToken = AuthHelper.GetUserToken();
            if(userToken === undefined || userToken === ''){
                throw Error("UserService -getUserPortalDetails-> token not set");
            }
            WebHelper.Instance.headers = 
            { 
                'Authorization': "Bearer " + userToken,
                'Accept': 'application/json',
                'X-Client': 'application',
                'Pragma': 'no-cache',
                'Cache-Control': 'no-cache'
            }
            
            const webInstance = WebHelper.Instance.getAxiosInstance();            
            return webInstance.post('user/AddFavorite',{detailKursusId: courseId});
        }catch (error) {
            throw error;
        }
    }
    
    public static removeUserFavoriteCourse(courseId: number): AxiosPromise<any> {
        try{
            const userToken = AuthHelper.GetUserToken();
            if(userToken === undefined || userToken === ''){
                throw Error("UserService -getUserPortalDetails-> token not set");
            }
            WebHelper.Instance.headers = 
            { 
                'Authorization': "Bearer " + userToken,
                'Accept': 'application/json',
                'X-Client': 'application',
                'Pragma': 'no-cache',
                'Cache-Control': 'no-cache'
            }
            
            const webInstance = WebHelper.Instance.getAxiosInstance();            
            return webInstance.post('user/removefavorite',{detailKursusId: courseId});
        }catch (error) {
            throw error;
        }
    }
    public static setUserTopics(topicIds: string[]): AxiosPromise<any> {
        try{
            const userToken = AuthHelper.GetUserToken();
            if(userToken === undefined || userToken === ''){
                throw Error("UserService -getUserPortalDetails-> token not set");
            }
            WebHelper.Instance.headers =
            { 
                'Authorization': "Bearer " + userToken,
                'Accept': 'application/json',
                'X-Client': 'application',
                'Pragma': 'no-cache',
                'Cache-Control': 'no-cache'
            }
            
            const webInstance = WebHelper.Instance.getAxiosInstance();                      
            return webInstance.post('user/SaveInterestedTopics',{categoryIdList: topicIds.join(',')});
        }catch (error) {
            throw error;
        }
    }
}


// WEBPACK FOOTER //
// ./src/Entities/User/User.Service.ts